import { createAction } from '@ngrx/store';

// TODO: Consider moving the login functionality to ngrx as well. Now we only use the login success call and not
// the actual login functionality itself.

export const loginSuccess = createAction('[Meta] Login Success');

export const logout = createAction('[Meta] Logout');
